export const constants = {
    contactEmail: "ddew@pmmi.org",
    contactPhone: "571.287.6822",
    drayageContactName: "Kim Valdes",
    drayageContactEmail: "onsite.expopack@rockit.global",
    genericForeignRfc: "XAXX010101000",
};
